"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4135],{

/***/ 94135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Sy": function() { return /* binding */ EnrichedTextSection_bs_make; }
});

// UNUSED EXPORTS: Description, KontentContextConsumer, LocalStyles, UniqueSellingPoints

// EXTERNAL MODULE: ./node_modules/rescript-classnames/src/Cn.bs.js
var Cn_bs = __webpack_require__(20859);
// EXTERNAL MODULE: ./node_modules/bs-css-emotion/src/Css.bs.js + 7 modules
var Css_bs = __webpack_require__(90289);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Array.js
var belt_Array = __webpack_require__(96533);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Option.js
var belt_Option = __webpack_require__(72491);
// EXTERNAL MODULE: ./src/components/pages/index/IndexStyles.bs.js
var IndexStyles_bs = __webpack_require__(28848);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Kontent/Kontent.bs.js
var Kontent_bs = __webpack_require__(72721);
// EXTERNAL MODULE: ./src/bindings/BsCss.bs.js + 1 modules
var BsCss_bs = __webpack_require__(71863);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Button/Button.bs.js + 1 modules
var Button_bs = __webpack_require__(10573);
// EXTERNAL MODULE: ./src/api/graphql/CallToAction/Gql__CallToAction__Decoder.bs.js
var Gql_CallToAction_Decoder_bs = __webpack_require__(93875);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Responsive.bs.js
var Theme_Responsive_bs = __webpack_require__(70965);
;// CONCATENATED MODULE: ./src/components/enrichedTextSection/EnrichedTextSectionCTA.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE







var EnrichedTextSectionCTA_bs_button = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(23)),
    tl: {
        hd: BsCss_bs/* media */.BC2(Theme_Responsive_bs/* tabletSmUp */.Uv, {
            hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(28)),
            tl: /* [] */ 0
        }),
        tl: {
            hd: BsCss_bs/* media */.BC2(Theme_Responsive_bs/* desktop */.gv, {
                hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(18)),
                tl: /* [] */ 0
            }),
            tl: /* [] */ 0
        }
    }
});
var LocalStyles = {
    button: EnrichedTextSectionCTA_bs_button
};
function EnrichedTextSectionCTA(props) {
    var parsedData = JSON.parse(props.data);
    var match = Gql_CallToAction_Decoder_bs/* parse_cta_style */.vn(parsedData.cta_style__style);
    var target = parsedData.open_in_new_window ? "_blank" : "";
    var href = parsedData.cta_url;
    return jsx_runtime.jsx(Button_bs.make, {
        children: jsx_runtime.jsx((link_default()), {
            href: href,
            prefetch: false,
            children: jsx_runtime.jsx("a", {
                children: jsx_runtime.jsx("button", {
                    children: parsedData.cta_text
                }),
                target: target
            })
        }),
        fill: match[2],
        colour: match[1],
        variant: match[0],
        className: EnrichedTextSectionCTA_bs_button
    });
}
var make = EnrichedTextSectionCTA;
 /* button Not a pure module */ 

// EXTERNAL MODULE: ./src/components/pages/index/KontentContextProvider.bs.js
var KontentContextProvider_bs = __webpack_require__(26396);
// EXTERNAL MODULE: ./src/utils/parseRichTextData.ts + 1 modules
var parseRichTextData = __webpack_require__(50771);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/UniqueSellingPoints/UniqueSellingPoints__List.bs.js
var UniqueSellingPoints_List_bs = __webpack_require__(15536);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/UniqueSellingPoints/UniqueSellingPoints__ListItem.bs.js
var UniqueSellingPoints_ListItem_bs = __webpack_require__(5495);
;// CONCATENATED MODULE: ./src/components/enrichedTextSection/EnrichedTextSectionList.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE








var list = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("flex"),
    tl: {
        hd: BsCss_bs/* flexDirection */.Me8("column"),
        tl: {
            hd: BsCss_bs/* textAlign */.ydu("left"),
            tl: {
                hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(23)),
                tl: {
                    hd: BsCss_bs/* media */.BC2(Theme_Responsive_bs/* tabletSmUp */.Uv, {
                        hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(28)),
                        tl: /* [] */ 0
                    }),
                    tl: {
                        hd: BsCss_bs/* media */.BC2(Theme_Responsive_bs/* desktop */.gv, {
                            hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(18)),
                            tl: /* [] */ 0
                        }),
                        tl: /* [] */ 0
                    }
                }
            }
        }
    }
});
var EnrichedTextSectionList_bs_LocalStyles = {
    list: list
};
function parseList(prim) {
    return ParseRichTextData.parseList(prim);
}
function EnrichedTextSectionList(props) {
    var items = parseRichTextData/* parseList */.B(props.data);
    var f = function f(idx, item) {
        var key = String(idx);
        return jsx_runtime.jsx(UniqueSellingPoints_ListItem_bs/* make */.S, {
            children: jsx_runtime.jsx("span", {
                dangerouslySetInnerHTML: {
                    __html: item
                }
            })
        }, key);
    };
    var content = belt_Array/* mapWithIndex */.Su(items, f);
    return jsx_runtime.jsx(UniqueSellingPoints_List_bs/* make */.Sy, {
        children: jsx_runtime.jsx("div", {
            children: content
        }),
        className: list
    });
}
var UniqueSellingPoints;
var List;
var ListItem;
var EnrichedTextSectionList_bs_make = EnrichedTextSectionList;
 /* list Not a pure module */ 

// EXTERNAL MODULE: ./src/components/CmsImage.bs.js
var CmsImage_bs = __webpack_require__(34442);
;// CONCATENATED MODULE: ./src/components/enrichedTextSection/EnrichedTextSectionImage.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function EnrichedTextSectionImage(props) {
    var parsedData = JSON.parse(props.data);
    var src = parsedData.url;
    var alt = parsedData.alt;
    var width = parsedData.width;
    var height = parsedData.height;
    var itemId = parsedData.id;
    var elementCodename = parsedData.codename;
    return jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
        children: jsx_runtime.jsx(CmsImage_bs/* make */.S, {
            src: src,
            alt: alt,
            width: width,
            height: height,
            className: "w-full mb-2",
            sizes: "(max-width: 1440px) 100vw, 1440px"
        }),
        itemId: itemId,
        elementCodename: elementCodename
    });
}
var EnrichedTextSectionImage_bs_make = EnrichedTextSectionImage;
 /* CmsImage Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Color.bs.js
var Theme_Color_bs = __webpack_require__(17845);
;// CONCATENATED MODULE: ./src/components/enrichedTextSection/EnrichedTextSectionNumberedList.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE






var EnrichedTextSectionNumberedList_bs_list = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("flex"),
    tl: {
        hd: BsCss_bs/* flexDirection */.Me8("column"),
        tl: {
            hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(23)),
            tl: {
                hd: BsCss_bs/* counterReset */.K03({
                    NAME: "reset",
                    VAL: [
                        "index",
                        0
                    ]
                }),
                tl: {
                    hd: BsCss_bs/* alignItems */.cq$("flexStart"),
                    tl: {
                        hd: BsCss_bs/* media */.BC2(Theme_Responsive_bs/* tabletSmUp */.Uv, {
                            hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(28)),
                            tl: /* [] */ 0
                        }),
                        tl: {
                            hd: BsCss_bs/* media */.BC2(Theme_Responsive_bs/* desktop */.gv, {
                                hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(18)),
                                tl: /* [] */ 0
                            }),
                            tl: {
                                hd: BsCss_bs/* selector */.nZE("li", {
                                    hd: BsCss_bs/* display */.jfB("flex"),
                                    tl: {
                                        hd: BsCss_bs/* alignItems */.cq$("flexStart"),
                                        tl: {
                                            hd: BsCss_bs/* textAlign */.ydu("left"),
                                            tl: {
                                                hd: BsCss_bs/* before */.bbn({
                                                    hd: BsCss_bs/* unsafe */.K47("content", 'counter(index) "."'),
                                                    tl: {
                                                        hd: BsCss_bs/* counterIncrement */.ga_({
                                                            NAME: "increment",
                                                            VAL: [
                                                                "index",
                                                                1
                                                            ]
                                                        }),
                                                        tl: {
                                                            hd: BsCss_bs/* display */.jfB("inlineBlock"),
                                                            tl: {
                                                                hd: BsCss_bs/* width */.bf$(BsCss_bs.em(2)),
                                                                tl: {
                                                                    hd: BsCss_bs/* textAlign */.ydu("left"),
                                                                    tl: {
                                                                        hd: BsCss_bs/* flex */.fUN("none"),
                                                                        tl: /* [] */ 0
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }),
                                                tl: /* [] */ 0
                                            }
                                        }
                                    }
                                }),
                                tl: /* [] */ 0
                            }
                        }
                    }
                }
            }
        }
    }
});
var EnrichedTextSectionNumberedList_bs_LocalStyles = {
    list: EnrichedTextSectionNumberedList_bs_list
};
function EnrichedTextSectionNumberedList_bs_parseList(prim) {
    return ParseRichTextData.parseList(prim);
}
function EnrichedTextSectionNumberedList(props) {
    var items = parseRichTextData/* parseList */.B(props.data);
    var f = function f(idx, item) {
        var key = String(idx);
        return jsx_runtime.jsx("li", {
            children: jsx_runtime.jsx("span", {
                dangerouslySetInnerHTML: {
                    __html: item
                }
            })
        }, key);
    };
    var content = belt_Array/* mapWithIndex */.Su(items, f);
    return jsx_runtime.jsx("ol", {
        children: content,
        className: EnrichedTextSectionNumberedList_bs_list
    });
}
var EnrichedTextSectionNumberedList_bs_UniqueSellingPoints;
var EnrichedTextSectionNumberedList_bs_List;
var EnrichedTextSectionNumberedList_bs_ListItem;
var EnrichedTextSectionNumberedList_bs_make = EnrichedTextSectionNumberedList;
 /* list Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/UniqueSellingPoints/UniqueSellingPoints__Description.bs.js
var UniqueSellingPoints_Description_bs = __webpack_require__(18868);
;// CONCATENATED MODULE: ./src/components/enrichedTextSection/EnrichedTextSection.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE
















function section(aligmentStyle, distanceTop, distanceBottom) {
    return curry._1(Css_bs/* style */.oBv, {
        hd: Css_bs/* textAlign */.ydu(aligmentStyle),
        tl: {
            hd: Css_bs/* display */.jfB("flex"),
            tl: {
                hd: Css_bs/* flexDirection */.Me8("row"),
                tl: {
                    hd: Css_bs/* justifyContent */.KlP("center"),
                    tl: {
                        hd: Css_bs/* marginTop */.E9m(belt_Option/* isNone */.Wi(distanceTop) ? Css_bs/* rem */.hOB(0.75) : Css_bs.px(belt_Option/* getWithDefault */.tj(distanceTop, 0))),
                        tl: {
                            hd: Css_bs/* marginBottom */.yl7(belt_Option/* isNone */.Wi(distanceBottom) ? Css_bs/* rem */.hOB(2.5) : Css_bs.px(belt_Option/* getWithDefault */.tj(distanceBottom, 0))),
                            tl: {
                                hd: Css_bs/* children */.pIy({
                                    hd: Css_bs/* lastChild */.QOo({
                                        hd: Css_bs/* marginBottom */.yl7(Css_bs/* zero */.bMI),
                                        tl: /* [] */ 0
                                    }),
                                    tl: /* [] */ 0
                                }),
                                tl: /* [] */ 0
                            }
                        }
                    }
                }
            }
        }
    });
}
var header = curry._1(Css_bs/* style */.oBv, {
    hd: Css_bs/* color */.$_Y(Theme_Color_bs/* Business.charcoal */.e.charcoal),
    tl: {
        hd: Css_bs/* marginBottom */.yl7(Css_bs.px(14)),
        tl: {
            hd: Css_bs/* fontWeight */.Ue2("semiBold"),
            tl: {
                hd: Css_bs/* media */.BC2(Theme_Responsive_bs/* tabletSmUp */.Uv, {
                    hd: Css_bs/* marginBottom */.yl7(Css_bs/* zero */.bMI),
                    tl: /* [] */ 0
                }),
                tl: {
                    hd: Css_bs/* media */.BC2(Theme_Responsive_bs/* desktop */.gv, {
                        hd: Css_bs/* marginBottom */.yl7(Css_bs.px(12)),
                        tl: /* [] */ 0
                    }),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
function innerContainer(blockWidth, alignment) {
    return curry._1(Css_bs/* style */.oBv, {
        hd: Css_bs/* display */.jfB("flex"),
        tl: {
            hd: Css_bs/* flexDirection */.Me8("column"),
            tl: {
                hd: Css_bs/* alignItems */.cq$(alignment),
                tl: {
                    hd: Css_bs/* width */.bf$(Css_bs/* pct */.hdZ(blockWidth)),
                    tl: {
                        hd: Css_bs/* media */.BC2(Theme_Responsive_bs/* tabletOrMobile */.k$, {
                            hd: Css_bs/* width */.bf$(Css_bs/* pct */.hdZ(100.0)),
                            tl: /* [] */ 0
                        }),
                        tl: {
                            hd: Css_bs/* selector */.nZE("a", {
                                hd: Css_bs/* color */.$_Y(Css_bs/* hex */.$v1("1A65F0")),
                                tl: {
                                    hd: Css_bs/* textDecoration */.QXS("underline"),
                                    tl: {
                                        hd: Css_bs/* hover */.MrM({
                                            hd: Css_bs/* color */.$_Y(Css_bs/* hex */.$v1("1E54B7")),
                                            tl: /* [] */ 0
                                        }),
                                        tl: {
                                            hd: Css_bs/* active */.bBs({
                                                hd: Css_bs/* color */.$_Y(Css_bs/* hex */.$v1("102C60")),
                                                tl: /* [] */ 0
                                            }),
                                            tl: {
                                                hd: Css_bs/* visited */.Fv({
                                                    hd: Css_bs/* color */.$_Y(Css_bs/* hex */.$v1("787878")),
                                                    tl: /* [] */ 0
                                                }),
                                                tl: /* [] */ 0
                                            }
                                        }
                                    }
                                }
                            }),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        }
    });
}
var h1 = curry._1(Css_bs/* style */.oBv, {
    hd: Css_bs/* fontSize */.JBY(Css_bs.px(50)),
    tl: {
        hd: Css_bs/* lineHeight */.Nv8(Css_bs.px(63)),
        tl: {
            hd: Css_bs/* media */.BC2(Theme_Responsive_bs/* tabletSm */.FV, {
                hd: Css_bs/* fontSize */.JBY(Css_bs.px(32)),
                tl: {
                    hd: Css_bs/* lineHeight */.Nv8(Css_bs.px(40)),
                    tl: /* [] */ 0
                }
            }),
            tl: /* [] */ 0
        }
    }
});
var h2 = curry._1(Css_bs/* style */.oBv, {
    hd: Css_bs/* fontSize */.JBY(Css_bs.px(40)),
    tl: {
        hd: Css_bs/* lineHeight */.Nv8(Css_bs.px(50)),
        tl: {
            hd: Css_bs/* media */.BC2(Theme_Responsive_bs/* tabletSm */.FV, {
                hd: Css_bs/* fontSize */.JBY(Css_bs.px(32)),
                tl: {
                    hd: Css_bs/* lineHeight */.Nv8(Css_bs.px(40)),
                    tl: /* [] */ 0
                }
            }),
            tl: /* [] */ 0
        }
    }
});
var h3 = curry._1(Css_bs/* style */.oBv, {
    hd: Css_bs/* fontSize */.JBY(Css_bs.px(36)),
    tl: {
        hd: Css_bs/* lineHeight */.Nv8(Css_bs.px(46)),
        tl: {
            hd: Css_bs/* media */.BC2(Theme_Responsive_bs/* tabletSm */.FV, {
                hd: Css_bs/* fontSize */.JBY(Css_bs.px(32)),
                tl: {
                    hd: Css_bs/* lineHeight */.Nv8(Css_bs.px(42)),
                    tl: /* [] */ 0
                }
            }),
            tl: /* [] */ 0
        }
    }
});
var h4 = curry._1(Css_bs/* style */.oBv, {
    hd: Css_bs/* fontSize */.JBY(Css_bs.px(32)),
    tl: {
        hd: Css_bs/* lineHeight */.Nv8(Css_bs.px(42)),
        tl: {
            hd: Css_bs/* media */.BC2(Theme_Responsive_bs/* tabletSm */.FV, {
                hd: Css_bs/* fontSize */.JBY(Css_bs.px(28)),
                tl: {
                    hd: Css_bs/* lineHeight */.Nv8(Css_bs.px(38)),
                    tl: /* [] */ 0
                }
            }),
            tl: /* [] */ 0
        }
    }
});
var EnrichedTextSection_bs_LocalStyles = {
    section: section,
    header: header,
    innerContainer: innerContainer,
    h1: h1,
    h2: h2,
    h3: h3,
    h4: h4
};
function EnrichedTextSection(props) {
    var block = props.block;
    var elements = block.content.elements;
    var width = block.width;
    var alignment = block.alignment;
    var distanceTop = block.distance_top;
    var distanceBottom = block.distance_bottom;
    var itemId = block.smartLink.itemId;
    var elementCodename = block.smartLink.codename;
    var f = function f(idx, item) {
        var key = String(idx);
        var data = item.data;
        var tag = item.tag;
        switch(tag){
            case "CTA":
                return jsx_runtime.jsx(make, {
                    data: data
                }, key);
            case "H1":
                return jsx_runtime.jsx("h1", {
                    className: Cn_bs/* make */.S([
                        h1,
                        header
                    ]),
                    dangerouslySetInnerHTML: {
                        __html: data
                    }
                }, key);
            case "H2":
                return jsx_runtime.jsx("h2", {
                    className: Cn_bs/* make */.S([
                        h2,
                        header
                    ]),
                    dangerouslySetInnerHTML: {
                        __html: data
                    }
                }, key);
            case "H3":
                return jsx_runtime.jsx("h3", {
                    className: Cn_bs/* make */.S([
                        h3,
                        header
                    ]),
                    dangerouslySetInnerHTML: {
                        __html: data
                    }
                }, key);
            case "H4":
                return jsx_runtime.jsx("h4", {
                    className: Cn_bs/* make */.S([
                        h4,
                        header
                    ]),
                    dangerouslySetInnerHTML: {
                        __html: data
                    }
                }, key);
            case "IMAGE":
                return jsx_runtime.jsx(EnrichedTextSectionImage_bs_make, {
                    data: data
                }, key);
            case "OL":
                return jsx_runtime.jsx(EnrichedTextSectionNumberedList_bs_make, {
                    data: data
                }, key);
            case "P":
                return jsx_runtime.jsx(UniqueSellingPoints_Description_bs/* make */.S, {
                    children: jsx_runtime.jsx("p", {
                        dangerouslySetInnerHTML: {
                            __html: data
                        }
                    })
                }, key);
            case "UL":
                return jsx_runtime.jsx(EnrichedTextSectionList_bs_make, {
                    data: data
                }, key);
            default:
                return null;
        }
    };
    var blockWidth;
    switch(width){
        case "n10_columns":
            blockWidth = 83.0;
            break;
        case "n12_columns":
            blockWidth = 100.0;
            break;
        case "n6_columns":
            blockWidth = 50.0;
            break;
        case "n8_columns":
            blockWidth = 66.0;
            break;
        default:
            blockWidth = 100.0;
    }
    var aligmentStyle;
    switch(alignment){
        case "center":
            aligmentStyle = "center";
            break;
        case "right":
            aligmentStyle = "right";
            break;
        default:
            aligmentStyle = "left";
    }
    var flexAlignment;
    switch(alignment){
        case "center":
            flexAlignment = "center";
            break;
        case "right":
            flexAlignment = "flexEnd";
            break;
        default:
            flexAlignment = "flexStart";
    }
    var content = belt_Array/* mapWithIndex */.Su(elements, f);
    return jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
        children: jsx_runtime.jsx(Kontent_bs/* Consumer.make */.$.make, {
            children: props.wallOfCards !== undefined ? jsx_runtime.jsx("div", {
                children: jsx_runtime.jsx("div", {
                    children: content,
                    className: innerContainer(blockWidth, flexAlignment)
                }),
                className: Cn_bs/* make */.S([
                    section(aligmentStyle, distanceTop, distanceBottom),
                    "mx-4"
                ])
            }) : jsx_runtime.jsx("section", {
                children: jsx_runtime.jsx("div", {
                    children: content,
                    className: innerContainer(blockWidth, flexAlignment)
                }),
                className: Cn_bs/* make */.S([
                    IndexStyles_bs/* section */.qi,
                    section(aligmentStyle, distanceTop, distanceBottom)
                ])
            })
        }),
        itemId: itemId,
        elementCodename: elementCodename
    });
}
var EnrichedTextSection_bs_UniqueSellingPoints;
var Description;
var KontentContextConsumer;
var EnrichedTextSection_bs_make = EnrichedTextSection;
 /* header Not a pure module */ 


/***/ })

}]);